<template>
  <div>
    <div>留言列表</div>
    <el-table :data="list" style="width: 100%" border stripe>
      <el-table-column prop="name" label="姓名"></el-table-column>
      <el-table-column prop="email" label="邮箱"></el-table-column>
      <el-table-column prop="address" label="地址"></el-table-column>
      <el-table-column prop="content" label="留言"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button type="danger" icon="el-icon-delete" circle @click="handleDelete(scope.row)"></el-button>
        </template>
      </el-table-column>
    </el-table>
  </div>
</template>

<script>
export default {
  data() {
    return {
      list: [
          {id:1,name:'赢一',email:'asd@qq.com',address:'中山路嘉华大厦C栋777室',content:'这是一个很不错的网站！'},
          {id:2,name:'老二',email:'asd@qq.com',address:'中山路嘉华大厦C栋777室',content:'这是一个很不错的网站！'},
          {id:3,name:'张三',email:'asd@qq.com',address:'中山路嘉华大厦C栋777室',content:'这是一个很不错的网站！'},
          {id:4,name:'李四',email:'asd@qq.com',address:'中山路嘉华大厦C栋777室',content:'这是一个很不错的网站！'},
          {id:5,name:'王五',email:'asd@qq.com',address:'中山路嘉华大厦C栋777室',content:'这是一个很不错的网站！'},
          {id:6,name:'马六',email:'asd@qq.com',address:'中山路嘉华大厦C栋777室',content:'这是一个很不错的网站！'},
          {id:7,name:'赵七',email:'asd@qq.com',address:'中山路嘉华大厦C栋777室',content:'这是一个很不错的网站！'},
          {id:8,name:'马八',email:'asd@qq.com',address:'中山路嘉华大厦C栋777室',content:'这是一个很不错的网站！'},
          {id:9,name:'幺九',email:'asd@qq.com',address:'中山路嘉华大厦C栋777室',content:'这是一个很不错的网站！'},
      ]
    };
  },
  methods:{
      handleDelete(){

      }
  }
};
</script>

<style lang="less" scoped>
</style>


// WEBPACK FOOTER //
// src/components/admin/leaveword.vue